import { getApp } from './firebaseApp';

import {
  handleNotification as handleNotificationOnLaunch,
  handleNotificationInForeground,
} from '../notificationsHandlers';
import { __ANDROID__ } from '../constants/styles';
import { PermissionsAndroid } from 'react-native';

let unregisterTokenRefreshListener = null;
let unregisterNotificationReceivedListener = null;
let androidChannelId = null;

const ANDROID_CHANNEL_ID = 'local_channel';

// format is different in iOS and Android so normalize here
function _normalizeMessageFormat(message) {
  const data = message.data;
  const notification = message.notification || message.data.notification;

  return {
    data,
    notification,
  };
}

function firebaseMessagingSupported() {
  let firebase = getApp();
  if (!firebase.messaging) return false;

  // the isSupported function only exists on mobile web
  if (firebase.messaging.isSupported && !firebase.messaging.isSupported()) return false;

  return true;
}

async function requestPushNotificationPermission() {
  try {
    const granted = await PermissionsAndroid.request(
      PermissionsAndroid.PERMISSIONS.POST_NOTIFICATIONS
    );
    if (granted !== PermissionsAndroid.RESULTS.GRANTED) {
      console.warn('Push notifications permission denied');
    }
  } catch (err) {
    console.error(err);
  }
}

export async function requestNotificationsPermissions() {
  let firebase = getApp();

  if (!firebaseMessagingSupported()) return Promise.reject();
  __ANDROID__ && (await requestPushNotificationPermission());
  return firebase.messaging().requestPermission();
}

export function registerForNotifications(onTokenRefresh) {
  let firebase = getApp();

  if (!firebaseMessagingSupported()) return;

  // explicityly call getToken here so that no matter how we get here during
  // the startup sequence we will pick up any changes to the token.
  // (don't rely on this sequence being executed before onTokenRefresh
  // event has fired on app startup)
  firebase
    .messaging()
    .getAPNSToken()
    .then((apnsToken) => {
      if (apnsToken || __ANDROID__) {
        firebase
          .messaging()
          .getToken()
          .then((fcmToken) => {
            if (fcmToken) {
              // console.info('****************************** got token');
              // user has a device token
              onTokenRefresh(fcmToken);
            } else {
              // user doesn't have a device token yet
            }
          })
          .catch((error) => {
            console.error('firebase.messaging().getToken() error', error);
            return Promise.resolve();
            // console.info('firebase.messaging().getToken() error', error);
          });
      } else {
        throw new Error('no APNS token');
      }
    })
    .catch((error) => {
      console.error('firebase.messaging().getAPNSToken() error', error);
      return Promise.resolve();
      // console.info('firebase.messaging().getToken() error', error);
    });

  unregisterTokenRefreshListener = firebase.messaging().onTokenRefresh((fcmToken) => {
    onTokenRefresh(fcmToken);
  });

  // web doesn't have onNotificationOpenedApp
  if (firebase.messaging().onNotificationOpenedApp) {
    // handle notification that brought an app from background to foreground
    firebase.messaging().onNotificationOpenedApp((message) => {
      // console.info('firebase onNotificationOpenedApp', message);
      handleNotificationOnLaunch(_normalizeMessageFormat(message));
    });

    // handle notification that launched an app that was closed
    firebase
      .messaging()
      .getInitialNotification()
      .then((message) => {
        if (message) {
          // console.info('getInitialNotification', message);
          handleNotificationOnLaunch(_normalizeMessageFormat(message), true);
        }
      });

    // this handles notifications that are received when the app is in the
    // foreground. Will be called for both popup notificaitions and data only
    // notification
    unregisterNotificationReceivedListener = firebase.messaging().onMessage((message) => {
      // console.info('>>>>>>>>>>>>>  onMessage', message);
      const normMessage = _normalizeMessageFormat(message);
      handleNotificationInForeground(normMessage);
    });
  }
}

export function unregisterFromNotifications() {
  unregisterTokenRefreshListener && unregisterTokenRefreshListener();
  unregisterNotificationReceivedListener && unregisterNotificationReceivedListener();
}
